import React from "react";

const DetailHead = ({ title }) => {
  return (
    <div
      style={{
        textAlign: "center",
        margin: "30px auto 30px",
      }}
      className="main_head_module_wrapper main_head_margin main_head_alignment_center"
    >
      <div className="main_head_text main_button main_head_padding">
        <h3
          className="main_button_title"
        >
          {title}
        </h3>
      </div>
    </div>
  );
};

export default DetailHead;
